import React, { Component } from "react";
import * as pageData from "./PageData";

export default class PageButtons extends Component {
    render() {
        return (
            <div className="test-page-buttons">
                {renderButtons(this.props)}
            </div>
        );
    }
}

function renderButtons(props) {
    switch (props.buttonsType) {
    case "all":
        return renderAll(props);
    case "be":
        return renderBe(props);
    case "bne":
        return renderBne(props);
    case "bn":
        return renderBn(props);
    case "consent":
        return renderConsent(props);
    case "next":
        return renderNext(props);
    case "finish":
        return renderFinish(props);
    case "safety":
        return renderSafety(props);
    default:
        return null;
    }
}

function renderAll(props) {
    return (
<React.Fragment>
    {renderPrevious(props)}
    {renderNext(props)}
    {renderSkip(props)}
</React.Fragment>
    );
}

function renderBe(props) {
    return (
<React.Fragment>
    {renderBack(props)}
    {renderEnd(props)}
</React.Fragment>
    );
}

function renderBne(props) {
        return (
<React.Fragment>
    {renderBack(props)}
    {renderNext(props)}
    {renderEnd(props)}
</React.Fragment>
    );
}

function renderBn(props) {
        return (
<React.Fragment>
    {renderBack(props)}
    {renderNext(props)}
</React.Fragment>
    );
}

function renderBack(props) {
    if (props.step % pageData.pagesPerTest > 3) {
        return <button key={'back-' + props.step} className="btn btn-primary" onClick={() => props.buttonClick("back")}>BACK</button>;
    }
    return renderPrevious(props);
}

function renderConsent(props) {
    const disabled = props.waitingForSpeech ? 'disabled' : '';
    return (
<React.Fragment>
    {renderPrevious(props)}
    <button key={'next-' + props.step} className="btn btn-success" onClick={() => props.buttonClick("next")} disabled={disabled}>I CONSENT</button>
    {renderSkip(props)}
</React.Fragment>
    );
}

function renderEnd(props) {
    return <button key={'end-' + props.step} className="btn btn-primary" onClick={() => props.buttonClick("end")}>END</button>;
}

function renderNext(props) {
    const disabled = props.disableNext || props.waitingForSpeech ? 'disabled' : '';
    return <button key={'next-' + props.step} className="btn btn-primary" onClick={() => props.buttonClick("next")} disabled={disabled}>NEXT</button>;
}

function renderFinish(props) {
    const disabled = props.disableNext || props.waitingForSpeech ? 'disabled' : '';
    return <button key={'next-' + props.step} className="btn btn-primary" onClick={() => props.buttonClick("next")} disabled={disabled}>FINISH</button>;
}

function renderPrevious(props) {
    if (props.trainingMode && props.step % pageData.pagesPerTest > 1) {
        return <button key={'prev-' + props.step} className="btn btn-warning" onClick={() => props.buttonClick("prev")}>PREVIOUS</button>;
    }
    return null;
}

function renderSkip(props) {
    if (props.trainingMode && ((props.step === 2) || (props.step === 3) || (props.step > pageData.pagesPerTest && props.step % pageData.pagesPerTest < 3))) {
        return <button key={'skip-' + props.step} className="btn btn-warning" onClick={() => props.buttonClick("skip")}>SKIP</button>;
    }
return null;
}

function renderSafety(props) {
    const disabled = props.waitingForSpeech ? 'disabled' : '';
    return (
        <React.Fragment>
            {renderPrevious(props)}
            <button key={'safe-' + props.step} className="btn btn-success" onClick={() => props.buttonClick("safe")} disabled={disabled}>SAFE</button>
            <button key={'unsafe-' + props.step} className="btn btn-danger" onClick={() => props.buttonClick("unsafe")} disabled={disabled}>UNSAFE</button>
    </React.Fragment>
    );
}
